module.exports = __webpack_public_path__ + "static/logo-8f336176a1a91a73e3d2778a4e6e1910.svg";